export default __webpack_public_path__ + "static/media/1935.b97fa65a.png";